import { darkTheme as iDarkTheme, theme as iLightTheme, ThemeProvider } from '@intelie/ui'
import React, { useContext } from 'react'
import { useTheme } from 'styled-components'

import { DashboardContext } from 'live/context/dashboard'
import liveTheme from 'live/services/theme'

import { SystemAudit } from './SystemAudit'

const lightTheme = { ...iLightTheme, ...liveTheme }
const darkTheme = { ...iDarkTheme, ...liveTheme }

export const SystemAuditWrapper: React.FC<{ urlParams: string[] }> = () => {
    const theme = useTheme()
    const dashTheme = useContext(DashboardContext).theme

    if (theme?.['gray-100']) {
        return <SystemAudit />
    } else {
        return (
            <ThemeProvider themeMerger={theme => theme} theme={dashTheme === 'light' ? lightTheme : darkTheme}>
                <SystemAudit />
            </ThemeProvider>
        )
    }
}
